import React, { useState } from 'react';
import {
  Box, Typography, CircularProgress, Snackbar, Alert,
  Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TableFooter, TablePagination, Link,
  IconButton, Backdrop, Chip
} from '@mui/material';
import { useQuery } from 'react-query';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import useIsDesktop from '../../../../Hooks/useIsDesktop';
import API from '../../../../API';
import { StyledTableRow } from '../../../../Utils/styledcell';

const rowsPerPage = 5;
const HideMobileCell = ({ children, ...props }) => {
  return (
    <TableCell
      sx={{ display: { xs: 'none', md: 'table-cell' } }}
      {...props}
    >
      {children}
    </TableCell>
  );
};

const fetchEmails = ({ queryKey }) => {
  const [, page] = queryKey;
  return API.creatorConnect.getEmails({ page, rows: rowsPerPage });
};

export default function IncomingPitches() {
  const [page, setPage] = useState(0);
  const [toastOpen, setToastOpen] = useState(false);

  const isDesktop = useIsDesktop();
  const { data, isFetching, error } = useQuery(
    ['creator_inbound', page],
    fetchEmails,
    { keepPreviousData: true, onError: () => setToastOpen(true) }
  );

  const rowCount = data?.total || 0;

  return (
    <Box sx={{ p: 4, maxWidth: 1200, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom fontWeight={800}>
        Inbound Leads
      </Typography>

      <Backdrop open={isFetching} sx={{ zIndex: 10, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        open={toastOpen}
        autoHideDuration={6000}
        onClose={() => setToastOpen(false)}
      >
        <Alert severity="error" variant="filled">
          {error ? error.response?.data?.error || error.message : ''}
        </Alert>
      </Snackbar>

      {data?.emails?.length ? (
        <TableContainer component={Paper} elevation={1}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '15rem' }}>Sender</TableCell>
                <TableCell sx={{ width: '30rem' }}>Content</TableCell>
                <HideMobileCell align="right">Date</HideMobileCell>
                <HideMobileCell align="right">Category</HideMobileCell>
                <TableCell align="center">Open</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.emails.map((row) => (
                <StyledTableRow key={row.thread_id}>
                  <TableCell>{row.sender}</TableCell>
                  <TableCell>
                    {row.subject}{' '}
                    <Typography variant="caption" color="text.secondary">
                      — {row.snippet}
                    </Typography>
                  </TableCell>
                  <HideMobileCell align="right">
                    {new Date(row.date_received).toLocaleString()}
                  </HideMobileCell>
                  <HideMobileCell align="right">
                    <Chip label={row.category} color="primary" />
                  </HideMobileCell>
                  <TableCell align="center">
                    <Link
                      href={`https://mail.google.com/mail/u/${row.receiver}/#all/${row.thread_id}`}
                      target="_blank"
                      underline="none"
                    >
                      <IconButton>
                        <OpenInNewIcon />
                      </IconButton>
                    </Link>
                  </TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={isDesktop ? 5 : 3}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={[rowsPerPage]}
                  count={rowCount}
                  onPageChange={(e, p) => setPage(p)}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      ) : (
        !isFetching && (
          <Alert severity="info" sx={{ mt: 4 }}>
            No inbound leads yet.
          </Alert>
        )
      )}
    </Box>
  );
}
